<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalArticulos: 0,
        total: "",
        state: true,
        id: 0,
        totalPendiente:0,
        totalPagado:0
      },
      no_venta:0,
      estadoCredito:null,
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      axios
          .get(
              process.env.VUE_APP_URL +
              "ventas/view_venta?id=" +
              this.$route.params.id,
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            console.log("response", response.data.orden);
            this.no_venta = response.data.orden.no_ducumento_v;
            this.estadoCredito = response.data.orden.estado_credito_v;
            let no_articulos = 0;
            this.formPro.totalPendiente = response.data.orden.saldo_credito_v
            this.formPro.totalPagado = (parseFloat(response.data.orden.total_v) - parseFloat(response.data.orden.saldo_credito_v)); 

            this.formPro.cliente =
                response.data.orden.cliente_rapido == "" ||response.data.orden.cliente_rapido==null
                    ? response.data.orden.cliente.persona.nombre_persona
                    : response.data.orden.cliente_rapido;

            this.formPro.total = response.data.orden.total_v;
            this.formPro.no_orden = response.data.orden.no_ducumento_v;
            this.formPro.empleado =
                response.data.orden.user.empleado.persona.nombre_persona +
                " " +
                response.data.orden.user.empleado.persona.apellido_persona;

            let detalleProducto = response.data.orden.detalle_ventas;
            let detalleServicio = response.data.orden.detalle_servicio_vs;
            console.log(detalleProducto);
            console.log(detalleServicio);

            if (detalleProducto.length > 0) {
              for (let i = 0; i < detalleProducto.length; i++) {
                no_articulos = no_articulos + detalleProducto[i].cantidad_venta;
                me.detalleorden.push({
                  cantidad: detalleProducto[i].cantidad_venta,
                  descripcion:
                      detalleProducto[i].producto.nombre_producto ,
                  valor_unitario: detalleProducto[i].precio_venta,
                  subtotal: detalleProducto[i].subtotal_venta,
                });
              }
            }

            if (detalleServicio.length > 0) {
              for (let i = 0; i < detalleServicio.length; i++) {
                no_articulos++;
                me.detalleorden.push({
                  cantidad: detalleServicio[i].cantidad_servicios,
                  descripcion:
                      detalleServicio[i].servicio.nombre_servicio ,
                  valor_unitario: detalleServicio[i].precio_servicio,
                  subtotal: detalleServicio[i].subtotal_servicio,
                });
              }
            }

            console.log("a", no_articulos);
            this.formPro.totalArticulos = no_articulos;
          });
    },
  },
};
</script>
<style>
/* .cabezera {
  float-right
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none"/>
    <div class="row mt-4">
      <div class="col d-print-none">
        <router-link
            :to="{
            name: 'ventas',
          }"
            class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
              ref="buttonImprimir"
              href="javascript:window.print()"
              class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="row">
            <div class="d-flex justify-content-center">
              <img
              class="img-fluid"
              style="max-width: 150px;"
                
                src="../../../../../src/assets/logo.png"
                alt="Logo"
              />
            </div>
          </div>
          <div class="card-body">
            <!-- <div class="invoice-title">
              <h4 class="float-end font-size-14">
                Cotización# {{ this.formPro.no_orden }}
              </h4>
            </div> -->
            <!-- <div class="row">
              <img
                  class="img-fluid float-right grises"
                  src="../../../../../src/assets/images/logoZonaR.png"
                  alt="Logo"
              />
            </div> -->
            <br/>
            <div class="row" align="center">
              <h2>Multi Repuestos San Jose</h2>
              <h2>Comapa Jutiapa</h2>
              <br/>
              <h2>Comapa Jutiapa</h2>
              <br/>
              <h2>TEL 3453, CLARO: 345, TIGO: 345</h2>
            </div>
            <div class="row" align="center">
              <h2>{{ showHour(new Date()) }} {{ estadoCredito ?',Venta al credito':''  }}</h2>
              <br/>
              <div class="col" align="left">
                <h2>CLIENTE:</h2>
                <h2>CAJERO:</h2>
                <h2>VENTA #</h2>
              </div>
              <div class="col" align="left">
                <h2>{{ formPro.cliente }}</h2>
                <h2>{{ formPro.empleado }}</h2>
                <h2>{{ no_venta }}</h2> 
              </div>
            </div>
            <div>
              <table class="table" style="margin-top: 0px; margin-bottom: 0px;">
                <thead style="margin-top: 0px; margin-bottom: 0px;">
                <tr>
                  <th><h3>CANT.</h3></th>
                  <th>
                    <h3>DESCRIPCIÓN</h3>
                  </th>
                  <th><h3>PRECIO</h3></th>
                  <th>
                    <h3>IMPORTE</h3>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, idx) in detalleorden" v-bind:key="idx">
                  <td>
                    <h3>
                      {{ item.cantidad }}
                    </h3>
                  </td>
                  <td>
                    <h3>
                      {{ item.descripcion }}
                    </h3>
                  </td>
                  <td>
                    <h3>
                      {{ money(item.valor_unitario) }}
                    </h3>
                  </td>
                  <td>
                    <h3>
                      {{ money(item.subtotal) }}
                    </h3>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="row" align="center">
                <h2>NO. DE ARTICULOS: {{ formPro.totalArticulos }}</h2>
                <h2>
                  <strong>TOTAL: {{ money(formPro.total) }}</strong>
                </h2>
                <div v-if="estadoCredito">
                  <h2>
                    <strong>SALDO RESTANTE: {{ money(formPro.totalPendiente) }}</strong>
                  </h2>
                  <h2>
                    <strong>SALDO PAGADO: {{ money(formPro.totalPagado) }}</strong>
                  </h2>
                </div>
              </div>
              <div class="row" align="center">
                <h4>
                  IMPORTANTE: Apreciable cliente en repuestos no se
                  aceptan cambios ni devoluciones. Para cambios y devoluciones
                  de otros artículos o productos es de 3 días hábiles, deberá
                  presentar su factura o comprobante de compra, el producto debe
                  encontrarse en las mismas condiciones en que fue entregado.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.grises {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}
table td {
    font-size: small;
  }
  table tr {
    margin-bottom: 5px; /* Puedes ajustar el valor según tus preferencias */
  }
</style>
